export enum EnquirusVaultRequestStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  MIXED = 'mixed',
  INFORMATION = 'information',
}

export enum EnquirusVaultTimepieceStatus {
  ALREADY_ADDED = 'ALREADY_ADDED',
  TO_ADD_ACCOUNT_NOT_CONFIRMED = 'TO_ADD_ACCOUNT_NOT_CONFIRMED',
  TO_ADD = 'TO_ADD',
}
